import React from 'react';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import { DocumentSetDataForm, DocumentSetFilters } from '../../../../app/models/DocumentSet';
import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DocumentSetSwitchChange from '../subcomponents/DocumentSetSwitchChange';
import DocumentSetFilter from './DocumentSetFilter';

interface Props {
    documentSets: DocumentSetDataForm[];
    totalRows: number;
    loading?: boolean;
    edit?: (id: number) => void;
    active?: (id: number, active: boolean) => void;
    show?: (id: number) => void;
    destroy?: (id: number) => void;
    filter: DocumentSetFilters;
    setFilter: (filter: DocumentSetFilters) => void;
    paginationRowsPerPageOptions?: any[];
    callbackSuccess: () => void;
    onSearch: () => void;
}

const DocumentSetDataTable = ({
    documentSets,
    totalRows,
    loading = false,
    edit,
    destroy,
    active,
    show,
    filter,
    setFilter,
    callbackSuccess,
    onSearch
}: Props) => {
    const columns = [
        {
            name: 'Id',
            selector: (row: any) => row.id,
            sortable: true,
            sortField: 'id',
            cell: (row: DocumentSetDataForm, index: any, column: any) => (
                <span className="">{row.id}</span>
            )
        },
        {
            name: 'Nombre del Set de Documentos',
            selector: (row: any) => row.name,
            sortable: true,
            sortField: 'name',
            cell: (row: DocumentSetDataForm, index: any, column: any) => (
                <span className="">{row.name}</span>
            )
        },
        {
            name: 'Activo',
            selector: (row: any) => row?.is_active,
            sortable: true,
            sortField: 'is_active',
            cell: (row: DocumentSetDataForm, index: any, column: any) => (
                <DocumentSetSwitchChange
                    checkValue={row.is_active ?? true}
                    documentSetId={row.id!}
                    callbackSuccess={callbackSuccess!}
                />
            )
        },
        {
            name: 'Acciones',
            selector: (row: any) => row.id,
            sortable: false,
            cell: (row: DocumentSetDataForm, index: any, column: any) => (
                <div className="">
                    {show && (
                        <ButtonTableAction
                            callbackFunction={() => show(row.id ?? -1)}
                            classIcon={'mdi mdi-eye'}
                            colorIcon={'text-info'}
                            errorMessage={'No se puede mostrar este registro.'}
                            title={'Ver'}
                        />
                    )}
                    {edit && (
                        <ButtonTableAction
                            callbackFunction={() => edit(row.id ?? -1)}
                            classIcon={'mdi mdi-pencil'}
                            colorIcon={'text-warning'}
                            errorMessage={'No se puede editar este registro.'}
                            title={'Editar'}
                        />
                    )}
                    {destroy && (
                        <ButtonTableAction
                            callbackFunction={() => destroy(row.id ?? -1)}
                            classIcon={'mdi mdi-delete'}
                            colorIcon={'text-danger'}
                            errorMessage={'No se puede eliminar este registro.'}
                            title={'Eliminar'}
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <>
            <div className="row mt-3">
                <div className="col">
                    <DocumentSetFilter filter={filter} setFilter={setFilter} onSearch={onSearch}/>
                </div>
            </div>
            <DefaultDataTable
                columns={columns}
                data={documentSets}
                progressPending={loading}
                paginationTotalRows={totalRows}
                filter={filter}
                setFilter={setFilter}
            />
        </>
    );
};

export default DocumentSetDataTable;
